import React from "react";
import './PortalGuideB2B.css';

const PortalGuideB2B = () => {
  return (
   
    <div className="fintech-features-area pt-100 pb-70">
      <div className="container mw-1320">
        <div className="saas-section-title text-center mx-auto">
          <h2>
            <span>FlyAbasin</span> Portal Guide: Easy, Efficient 


            <span> B2B Flight Booking</span>.
          </h2>
        </div>
        <div className="row align-items-center">
          <div className="col-lg-4">
            <div className="featured-img text-center">
              <img
                decoding="async"
                src="https://wallpapers.com/images/hd/flight-attendant-pictures-gtbl6c3imrtyjgie.jpg"
                alt="icon1"
              />
            </div>
          </div>
          <div className="col-lg-8">
            <div className="position-relative">
              <div className="row">
                <div className="col-sm-12 col-lg-12 col-xl-6">
                  <div className="fintech-feature-card">
                    <h3>Explore 600+ Airline Services</h3>
                    <p>
                      Once registered, you access a huge database of more than
                      600 airline services. Check the available options to find
                      the best for your clients.
                    </p>
                  </div>
                </div>
                <div className="col-sm-12 col-lg-12 col-xl-6">
                  <div className="fintech-feature-card">
                    <h3>Effortless Search</h3>
                    <p>
                  Use an intuitive search with key details like destination, dates, and preferences to quickly find the most suitable flights for your customers.
                    </p>
                  </div>
                </div>
                <div className="col-sm-12 col-lg-12 col-xl-6">
                  <div className="fintech-feature-card">
                    <h3>Make a Purchase</h3>
                    <p>
                      After identifying the perfect flights, proceed to purchase
                      through our portal. The booking process is made for your
                      convenience
                    </p>
                  </div>
                </div>
                <div className="col-sm-12 col-lg-12 col-xl-6">
                  <div className="fintech-feature-card">
                    <h3>Instant Commission
</h3>
                    <p>
Earn commission easily—automatically added to your statement after purchase confirmation. No hassle, just straightforward earnings.




                    </p>
                  </div>
                </div>
              </div>
              {/* <div className="fintech-brand-icon d-none d-xxl-block">
                <img
                  decoding="async"
                  src="/abasinlogo.png"
                  alt="icon1"
                  style={{ height: "30px" }}
                />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortalGuideB2B;
